import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, ModalView } from '../..';
import { AppContext } from '../../../context/AppContext';
import { emptyConstancyProduct, emptyInspection } from '../../../emptyObjects';
import { useResource } from '../../../hooks';
import { ConstancyProduct, Inspection, UpdatedConstancyProduct } from '../../../interfaces';
import ConstancyProductForm from '../ConstancyProductForm';

import './styles.scss';
import { utils } from '../../../helpers';

interface Props {
  visible: boolean
  title?: string
  clientID?: string
  collaboratorID?: string
  serviceID?: string
  preloadedProduct?: ConstancyProduct
  onCreateProduct?: (_product: ConstancyProduct) => void
  onUpdateProduct?: (_product: ConstancyProduct) => void
  onClose: () => void
  onError?: (_error: string) => void
  inspectionLookInTheTrash?: boolean
}

const ModalViewConstancyProduct: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  const {
    visible = true,
    title = t('services.productFormTitle') || '',
    preloadedProduct = emptyConstancyProduct,
    onCreateProduct = (_product: ConstancyProduct) => { },
    onUpdateProduct = (_product: ConstancyProduct) => { },
    onClose = () => { },
    onError = (_error: string) => { },
    inspectionLookInTheTrash = false
  } = props;

  let {
    clientID,
    collaboratorID,
    serviceID
  } = props;

  const {
    fetchResource
  } = useResource<Inspection>();

  const [inspection, setInspection] = useState<Inspection>(emptyInspection);

  if (preloadedProduct) {
    if (!clientID) {
      clientID = preloadedProduct.client.id;
    }
    if (!collaboratorID) {
      collaboratorID = preloadedProduct.collaborator.id;
    }
    if (!serviceID) {
      serviceID = preloadedProduct.service.id;
    }
  }

  const {
    updateResource
  } = useResource<UpdatedConstancyProduct>();

  const {
    createResource
  } = useResource<ConstancyProduct[]>();

  const {
    apiType,
    soundEffects,
    setOpenModal
  } = useContext(AppContext);

  useEffect(() => {
    if (
      preloadedProduct.inspection
      && preloadedProduct.inspection?.id !== ''
      && preloadedProduct.inspection?.id !== undefined
    ) {
      fetchResource(
        `/${apiType}/inspections/${preloadedProduct.inspection?.id}?b_lookInTheTrash=${inspectionLookInTheTrash ? 'true' : ''}`,
        (data) => {
          setInspection(data);
        },
        (error) => Modal.fireError(error, setOpenModal, soundEffects)
      );
    }
  }, [preloadedProduct]);

  return (
    <ModalView
      visible={visible}
      onClose={onClose}
      customComponent={
        <div className='form-container'>
          <ConstancyProductForm
            title={title}
            cleanStates={visible}
            preloadedProduct={preloadedProduct}
            disableInputs={
              inspection.id
                && (inspection.complies !== null
                  || !!utils.getCurrentRound(inspection.rounds).steps.find(element => element === 'product-updated')
                  || utils.getCurrentRound(inspection.rounds).list !== null)
                ? ['normCode', 'fase', 'code']
                : []}
            onCreateProduct={(product: ConstancyProduct) => {
              createResource(
                `/${apiType}/constancy-products`,
                {
                  products: [product],
                  clientID,
                  collaboratorID,
                  constancyServiceID: serviceID
                },
                (data) => {
                  onCreateProduct(data[0]);
                  onClose();
                },
                (error) => {
                  onError(error);
                }
              );
            }}
            onUpdateProduct={(product: ConstancyProduct) => {
              updateResource(
                `/${apiType}/constancy-products/${product?.id}`,
                product,
                (data) => {
                  onUpdateProduct(data.product);
                  onClose();
                },
                (error: string) => {
                  onError(error);
                }
              );
            }}
          />
        </div>
      }
    />
  );
};

export default ModalViewConstancyProduct;
